import React from "react";
import styled from "styled-components";
import { Group } from "@domain/group/group";
import { gap } from "@ui/styles/utils";
import { ShareroomWorkspace } from "@ui/pages/group/workspace/shareroomWorkspace";
import { WorkspaceList } from "@ui/pages/group/workspace/workspaceList";

interface ShareroomWorkspacesProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
	workspaceId?: string;
	slugWorkspace: string;
}
export const ShareroomWorkspaces: React.FC<ShareroomWorkspacesProps> = ({
	shareroom,
	workspaceId,
	slugWorkspace,
	...htmlProps
}) => {
	return (
		<Container {...htmlProps}>
			{workspaceId ? (
				<ShareroomWorkspace
					isAdmin={shareroom.userRole === "ADMINISTRATOR"}
					workspaceId={workspaceId}
					shareroom={shareroom}
					slugWorkspace={slugWorkspace}
				/>
			) : (
				<FullSizeWorkspaceList shareroom={shareroom} />
			)}
		</Container>
	);
};

const Container = styled.div`
	${gap(40)};
`;

const FullSizeWorkspaceList = styled(WorkspaceList)`
	align-self: stretch;
	flex: 1;
`;
